<template>
    <gateway-demo-frame
        demo_route_name="crm-account-confirmation-demo-start"
        hero_icon="mdi-account-details"
        hero_title="Account Confirmation Experience Demo"
        hero_subtitle="Interactive demonstration of contact information verification via bulk messaging campaign"
        :business_impact_items="benefits"
        :experience_flow_steps="flow_steps"
        :compliance_items="compliance_items"
    />
</template>

<script>
import GatewayDemoFrame from '@/components/demos/shared/gateway-frame.vue';

export default {
    name: 'CRMAccountConfirmationDemoIntro',

    components: {
        GatewayDemoFrame
    },

    data() {
        return {
            benefits: [
                {
                    icon: 'mdi-database-check',
                    title: 'Improved Data Accuracy',
                    description: 'Keep customer contact information current and reduce delivery failures and communication issues'
                },
                {
                    icon: 'mdi-account-multiple-check',
                    title: 'Enhanced Customer Engagement',
                    description: 'Regular touchpoints build relationships while ensuring customers can be reached when needed'
                },
                {
                    icon: 'mdi-shield-check',
                    title: 'Proactive Compliance Management',
                    description: 'Maintain up-to-date consent records and provide customers easy opt-out options'
                }
            ],
            flow_steps: [
                {
                    number: 1,
                    title: 'Campaign Created',
                    description: 'Business creates "spring cleaning" campaign with personalized confirmation links'
                },
                {
                    number: 2,
                    title: 'SMS Notification',
                    description: 'Customers receive text with secure link to review their contact information'
                },
                {
                    number: 3,
                    title: 'Information Review',
                    description: 'Customer confirms or updates details, maintaining accurate CRM records'
                }
            ],
            compliance_items: [
                {
                    icon: 'mdi-shield-sync',
                    title: 'Consent Refresh Opportunity',
                    description: 'Natural touchpoint to re-verify customer preferences and communication consent'
                },
                {
                    icon: 'mdi-file-document-check',
                    title: 'Audit Trail Maintained',
                    description: 'Documentation of customer-initiated confirmations and updates strengthens compliance posture'
                }
            ]
        }
    },

    mounted() {
        document.title = "CRM Account Confirmation Demo | RedChirp";
    }
}
</script>